var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.block.class, {'half-padding-top': _vm.block.half_padding_top}, {'half-padding-bottom': _vm.block.half_padding_bottom}],attrs:{"id":_vm.block.anchor ? _vm.block.anchor : ('block-' + _vm.block.id)},domProps:{"innerHTML":_vm._s(_vm.block.video)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235a5cd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/modules/FullscreenVideoBlock.vue
// module id = null
// module chunks = 